/* istanbul ignore file */
import { FormRow, BigFormRow, FormSection } from 'framework/ui/layout';
import { DateInput, TextArea, TextInput } from 'framework/form';
import { DocumentScanUploaderInput } from 'domain/shared/employee';
import { CurrencyDropdown } from 'domain/shared/core/input';
import FinanceTypeDropdown from 'domain/people/employee/finance/shared/inputs/FinanceTypeDropdown';
import { BaseAmountTypeDropdown, OfficeDropdown, ProbationPeriodReductionInput } from 'domain/shared/employee';

const FinanceForm = () => {
  return (
    <FormSection>
      <FormRow>
        <FinanceTypeDropdown source="type" label="Type" />
        <DateInput source="effectiveDateFrom" label="Effective date from" />
        <DateInput source="effectiveDateTo" label="Effective date to (including)" />
        <BaseAmountTypeDropdown source="baseAmountType" label="Base amount type" />
        <TextInput source="grossAmount" label="Base amount gross" />

        <CurrencyDropdown source="currency" label="Currency" />
        <ProbationPeriodReductionInput
          source="probationReduction"
          probationAmountSource="grossProbationAmount"
          baseAmountSource="grossAmount"
          label="Probation period reduction, %"
        />
        <TextInput source="grossProbationAmount" label="Probation period absolute value gross" />
        <DateInput source="firstDay" label="First day of base value application" />
        <OfficeDropdown source="officeId" label="Office" />
      </FormRow>
      <BigFormRow>
        <TextArea label="Additional expenses compensated" source="additionalExpenses" />
      </BigFormRow>
      <BigFormRow>
        <DocumentScanUploaderInput label="Document scans" source="scansIds" />
      </BigFormRow>
    </FormSection>
  );
};

export default FinanceForm;
